(function() {

    document.querySelectorAll('.comparative-table-block').forEach(block => {
        document.querySelectorAll('.comparative-tab-container-header').forEach(header => {
            header.addEventListener('click', () => {
                const container = header.closest('.comparative-tab-container');
                container.classList.toggle('active');
            });
        });
    });

})();